import {useEffect} from "react";
import {getAppointments} from "../../api/Appointment";

interface UseCalendarAppointmentsParams {
  navigate: (path: string) => void;
  from: string;
  setAllAppointment: (appointments: AppointmentItem[]) => void;
  tick: number;
}

function useCalendarAppointments({
                                   navigate,
                                   from,
                                   setAllAppointment,
                                   tick,
                                 }: UseCalendarAppointmentsParams) {
  const fetchAndSetAppointments = async () => {
    try {
      const response = await getAppointments(from);
      const processedAppointments = processAppointments(response);
      setAllAppointment(processedAppointments);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAndSetAppointments();
  }, [tick]);

  return {fetchAndSetAppointments};
}

// Helper function to process appointments
function processAppointments(appointments: AppointmentItem[]): AppointmentItem[] {
  const sortedData = appointments.sort(
    (a: AppointmentItem, b: AppointmentItem) =>
      Date.parse(a.startTime) - Date.parse(b.startTime)
  );

  return sortedData.map((item) => {
    const date = new Date(item.startTime);
    const time = `${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}`;

    return {
      id: item.id,
      title: item.title,
      oktaSub: item.oktaSub,
      time: time,
      startTime: item.startTime,
      endTime: item.endTime,
      state: item.state,
      name: item.name,
      selected: false,
      version: item.version,
    };
  });
}

export default useCalendarAppointments;
